import { TransportCardInterface } from 'store/ducks/transportCards/types';
import { UserDocumentsInterface } from '../users/types';

/*
 * Action Types
 */
export enum CollaboratorsTypes {
  LIST_COLLABORATORS_REQUEST = '@collaborators/LIST_COLLABORATORS_REQUEST',
  LIST_COLLABORATORS_SUCCESS = '@collaborators/LIST_COLLABORATORS_SUCCESS',
  LIST_COLLABORATORS_FAILURE = '@collaborators/LIST_COLLABORATORS_FAILURE',

  GET_COLLABORATOR_REQUEST = '@collaborators/GET_COLLABORATOR_REQUEST',
  GET_COLLABORATOR_SUCCESS = '@collaborators/GET_COLLABORATOR_SUCCESS',
  GET_COLLABORATOR_FAILURE = '@collaborators/GET_COLLABORATOR_FAILURE',

  FILTER_COLLABORATORS_REQUEST = '@collaborators/FILTER_COLLABORATORS_REQUEST',
  FILTER_COLLABORATORS_SUCCESS = '@collaborators/FILTER_COLLABORATORS_SUCCESS',
  FILTER_COLLABORATORS_FAILURE = '@collaborators/FILTER_COLLABORATORS_FAILURE',

  CREATE_COLLABORATOR_REQUEST = '@collaborators/CREATE_COLLABORATOR_REQUEST',
  CREATE_COLLABORATOR_SUCCESS = '@collaborators/CREATE_COLLABORATOR_SUCCESS',
  CREATE_COLLABORATOR_FAILURE = '@collaborators/CREATE_COLLABORATOR_FAILURE',

  UPDATE_COLLABORATOR_REQUEST = '@collaborators/UPDATE_COLLABORATOR_REQUEST',
  UPDATE_COLLABORATOR_SUCCESS = '@collaborators/UPDATE_COLLABORATOR_SUCCESS',
  UPDATE_COLLABORATOR_FAILURE = '@collaborators/UPDATE_COLLABORATOR_FAILURE',

  DELETE_COLLABORATOR_REQUEST = '@collaborators/DELETE_COLLABORATOR_REQUEST',
  DELETE_COLLABORATOR_SUCCESS = '@collaborators/DELETE_COLLABORATOR_SUCCESS',
  DELETE_COLLABORATOR_FAILURE = '@collaborators/DELETE_COLLABORATOR_FAILURE',

  CREATE_COLLABORATORS_REQUEST = '@collaborators/CREATE_COLLABORATORS_REQUEST',
  CREATE_COLLABORATORS_SUCCESS = '@collaborators/CREATE_COLLABORATORS_SUCCESS',
  CREATE_COLLABORATORS_FAILURE = '@collaborators/CREATE_COLLABORATORS_FAILURE',

  LINK_COLLABORATOR_TO_COMPANY_REQUEST = '@collaborators/LINK_COLLABORATOR_TO_COMPANY_REQUEST',
  LINK_COLLABORATOR_TO_COMPANY_SUCCESS = '@collaborators/LINK_COLLABORATOR_TO_COMPANY_SUCCESS',
  LINK_COLLABORATOR_TO_COMPANY_FAILURE = '@collaborators/LINK_COLLABORATOR_TO_COMPANY_FAILURE',

  UNLINK_COLLABORATOR_FROM_COMPANY_REQUEST = '@collaborators/UNLINK_COLLABORATOR_FROM_COMPANY_REQUEST',
  UNLINK_COLLABORATOR_FROM_COMPANY_SUCCESS = '@collaborators/UNLINK_COLLABORATOR_FROM_COMPANY_SUCCESS',
  UNLINK_COLLABORATOR_FROM_COMPANY_FAILURE = '@collaborators/UNLINK_COLLABORATOR_FROM_COMPANY_FAILURE',

  UPDATE_COLLABORATORS_REQUEST = '@collaborators/UPDATE_COLLABORATORS_REQUEST',
  UPDATE_COLLABORATORS_SUCCESS = '@collaborators/UPDATE_COLLABORATORS_SUCCESS',
  UPDATE_COLLABORATORS_FAILURE = '@collaborators/UPDATE_COLLABORATORS_FAILURE',

  DELETE_COLLABORATORS_REQUEST = '@collaborators/DELETE_COLLABORATORS_REQUEST',
  DELETE_COLLABORATORS_SUCCESS = '@collaborators/DELETE_COLLABORATORS_SUCCESS',
  DELETE_COLLABORATORS_FAILURE = '@collaborators/DELETE_COLLABORATORS_FAILURE',
}

/*
 * Data types
 */
export interface CollaboratorInterface {
  id: string;
  name: string;
  email: string;
  phone: string;
  document: string;
  photoUrl: string;
  createdAt: string;
  updatedAt: string;
  TransportCards?: TransportCardInterface[];
  UserDocuments: UserDocumentsInterface[];
}

/*
 * State type
 */
export interface CollaboratorsState {
  readonly collaboratorsList: CollaboratorInterface[];
  readonly collaboratorData: CollaboratorInterface;
  readonly linkCollaboratorCompanyData: any;
  readonly unlinkCollaboratorCompanyData: any;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
/*
    responseCollaboratorsCreated: Array<object> // array of errors and success
    responseCollaboratorsEdited:  Array<object> // array of errors and success
    responseCollaboratorsDeleted: Array<object> // array of errors and success
*/
